import { CopyTwoTone } from '@ant-design/icons';
import ZeissButton from '@components/button';
import { Modal, Space, message } from 'antd';
import './index.scss';
interface Props {
  open: boolean;
  handleCancel?: () => void;
  details: any;
}
export const useAccountPopup = ({
  open,
  handleCancel,
  details = {}
}: Props) => {
  const { vendorAccount, vendorPwd } = details;
  const copyText = async (acc: string, pwd?: string) => {
    if (pwd) {
      const text = `千里马账号: ${acc} , 密码：${pwd}`;
      await navigator.clipboard.writeText(text);
      message.success('复制成功');
    } else {
      await navigator.clipboard.writeText(acc);
      message.success('复制成功');
    }
  };

  let accountComponent = (
    <Modal
      width={520}
      open={open}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      centered
    >
      <div className="pc-accountPopup-layout">
        <div className="pc-accountPopup-title">千里马账号密码</div>
        <div className="pc-accountPopup-content">
          <div className="pc-accountPopup-line">
            <div className="pc-accountPopup-label">千里马账号：</div>
            <div className="pc-accountPopup-val">{vendorAccount}</div>
            <CopyTwoTone
              twoToneColor="#C2CDD6"
              onClick={() => copyText(vendorAccount)}
            />
          </div>
          <div className="pc-accountPopup-line">
            <div className="pc-accountPopup-label">密码：</div>
            <div className="pc-accountPopup-val">{vendorPwd}</div>
            <CopyTwoTone
              twoToneColor="#C2CDD6"
              onClick={() => copyText(vendorPwd)}
            />
          </div>
        </div>
        <Space className="pc-accountPopup-footer" size="middle">
          <ZeissButton className="pc-normal-btn" onClick={handleCancel}>
            取消
          </ZeissButton>
          <ZeissButton
            htmlType="submit"
            className="pc-confirm-btn"
            onClick={() => copyText(vendorAccount, vendorPwd)}
          >
            复制账号密码
          </ZeissButton>
        </Space>
      </div>
    </Modal>
  );
  return {
    accountComponent
  };
};
